export enum ApiRoutesContent {
  AllVideos = "video/general/guide/all",
  Video = "video/admin/guide",
  VideoDelete = "video/admin",
  PrivacyAndTerms = "flex-data/privacy-and-terms",
  AboutUs = "flex-data/about-us",
  Socials = "flex-data/social-media",
  FAQItems = "admin/faq",
  FAQItemsReorder = "admin/faq/reorder",
  Quizzes = "flex-data/quizzes",
  InfoBar = "flex-data/chap-shop-information-for-users",
  FeedInserts = "admin/product-feed-inserts",
  FeedInsertsSettings = "admin/product-feed-inserts/settings",
  FeedInsertsReorder = "reorder",
  Announcement = "admin/announcements"
}

export enum ContentVideoTargetResellerLevel {
  Buyer = "Buyer",
  Reseller = "Reseller"
}

export enum QuizItemStatuses {
  Active = "Active",
  Inactive = "Inactive"
}

export const QUIZ_ITEM_STATUSES_LIST = [
  {
    label: "Active",
    value: QuizItemStatuses.Active,
    backgroundColor: "#16C350"
  },
  {
    label: "Inactive",
    value: QuizItemStatuses.Inactive,
    backgroundColor: "#A8A8BB"
  }
];

export enum FeedInsertWidth {
  FullWidth = "FullWidth",
  FullWidthThin = "FullWidthThin",
  ProductSize = "ProductSize"
}

export enum FeedInsertType {
  SingleMedia = "SingleMedia",
  MultipleMedia = "MultipleMedia",
  Products = "Products"
}
